/* eslint-disable @foxglove/no-boolean-parameters */
import { localize } from "@gtmhub/localization";

export const goalConfig = () => ({
  titleKey: "okr",
  opts: [
    {
      fieldName: "cloneChildren",
      displayName: localize("clone_all_child_okrs"),
      additionalInfo: localize("clone_all_child_okrs_help"),
    },
    { fieldName: "cloneTasks", displayName: localize("clone_tasks") },
    { fieldName: "notifications", displayName: localize("send_notifications") },
    { fieldName: "duplicateInsight", displayName: localize("duplicate_insights_related_to_dynamic_kr"), additionalInfo: localize("duplicate_insights_help") },
  ],
  selectFrom: localize("select_session_or_okr_clone"),
});

export const metricConfig = (showDuplicateInsight: boolean, isKeepProgressAndUpdateSyncFeatureAvailable: boolean) => ({
  titleKey: "key_result_both_cap",
  opts: [
    { fieldName: "notifications", displayName: localize("send_notifications") },
    ...(showDuplicateInsight
      ? [
          {
            fieldName: "duplicateInsight",
            displayName: localize("duplicate_insight"),
            tooltip: localize("duplicate_insight_kr_help"),
          },
        ]
      : []),
    ...(isKeepProgressAndUpdateSyncFeatureAvailable
      ? [
          {
            fieldName: "sync",
            displayName: localize("keep_progress_and_updates_in_sync"),
            tooltip: localize("keep_progress_and_updates_in_sync_desc"),
          },
        ]
      : []),
  ],
  selectFrom: localize("select_okr"),
});
